// import React, { useEffect } from "react";
// import "./App.css";
// import { useSelector, useDispatch } from "react-redux";
// import { Routes, Route } from "react-router";
// import Admin from "./admin";
// import Manager from "./manager";
// import User from "./user";
// import LogIn from "./logIn";
// import { ToastContainer } from "react-toastify";
// import { setCredentials } from "./redux-state/features/user/userSlice";
// function App() {
//   const dispatch = useDispatch();
//   const { userType, isAuthenticated } = useSelector((state) => state.userState);

//   useEffect(() => {
//     const token = localStorage.getItem("token");
//     const user = JSON.parse(localStorage.getItem("user"));

//     if (token && user) {
//       dispatch(
//         setCredentials({
//           token,
//           user_type: user.user_type,
//           uuid: user.uuid,
//           email: user.email,
//           userName: user.full_name,
//         })
//       );
//     }
//   }, [dispatch]);
//   return (
//     <div>
//       <ToastContainer
//         position="top-right"
//         autoClose={5000}
//         rtl={true}
//         pauseOnFocusLoss
//         draggable
//         pauseOnHover
//       />
//       {isAuthenticated ? (
//         <>
//           {userType === "admin" && <Admin />}
//           {userType === "store_manager" && <Manager />}
//           {userType === "user" && <User />}
//         </>
//       ) : (
//         <LogIn />
//       )}
//     </div>
//   );
// }

import React, { useEffect } from "react";
import "./App.css";
import { useSelector, useDispatch } from "react-redux";
import { Outlet, useLocation, Navigate, useNavigate } from "react-router"; // Use Navigate
import { ToastContainer } from "react-toastify";
import { setCredentials } from "./redux-state/features/user/userSlice";
import { setGlobalSettings } from "./redux-state/features/setting/settingsSlice";
import axios from "axios";
import urls from "./urls";
function processSettings(settingsArray) {
  return settingsArray.reduce((acc, { setting_name, setting_value }) => {
    acc[setting_name] = setting_value;
    return acc;
  }, {});
}
function App() {
  const dispatch = useDispatch();
  const location = useLocation(); // Track current path
  const { userType, isAuthenticated, faculty_id } = useSelector(
    (state) => state.userState
  );
  const navigate = useNavigate();
  useEffect(() => {
    const token = localStorage.getItem("token");
    const user = JSON.parse(localStorage.getItem("user"));

    if (token && user) {
      axios
        .post(urls.newSettings, {
          faculty: user.faculty_id,
        })
        .then((res) => {
          axios
            .get(urls.getSettings)
            .then((res) => {
              const settings = processSettings(res.data);

              dispatch(setGlobalSettings(settings));
            })
            .catch((err) => {
              console.error("could not get Setting ", err);
            });
        })
        .catch((err) => {
          console.error("could not add new Setting ", err);
        });
      dispatch(
        setCredentials({
          token,
          user_type: user.user_type,
          uuid: user.uuid,
          email: user.email,
          userName: user.full_name,
          faculty_id: user.faculty_id,
          faculty_name: user.faculty_name,
          mustChangePswd: user.mustChangePswd,
        })
      );
      if (location.pathname === "/") {
        switch (userType) {
          case "admin":
            navigate("/admin");
            break;
          // return <Navigate to="/admin" replace />;
          case "store_manager":
            navigate("/manager");
            break;
          // return <Navigate to="/manager" replace />;
          case "user":
            navigate("/user");
            break;
          case "inventory_officer":
            navigate("/inventory");
            break;
          // return <Navigate to="/user" replace />;
          default:
            // return <Navigate to="/login" replace />;
            navigate("/");
            break;
        }
      }
    } else {
      return navigate("/");
    }
  }, [dispatch, isAuthenticated]);

  // useEffect(() => {
  //   console.log("userType ", userType);
  //   if (
  //     !isAuthenticated ||
  //     location.pathname === "/" ||
  //     location.pathname === "/login"
  //   ) {
  //     // if (!isAuthenticated) {
  //     //   return <Navigate to="/login" replace />;
  //     // }

  //     switch (userType) {
  //       case "admin":
  //         navigate("/admin");
  //         break;
  //       // return <Navigate to="/admin" replace />;
  //       case "store_manager":
  //         navigate("/manager");
  //         break;
  //       // return <Navigate to="/manager" replace />;
  //       case "user":
  //         navigate("/user");
  //         break;
  //       // return <Navigate to="/user" replace />;
  //       default:
  //         // return <Navigate to="/login" replace />;
  //         navigate("/login");
  //         break;
  //     }
  //   }
  // }, []);

  return (
    <div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        rtl={true}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      {/* Render nested routes */}
      <Outlet />
    </div>
  );
}

export default App;
